import AccordionComponent from './AccordionComponent'
import { AccordionElement } from './AccordionItems'

export default AccordionComponent
export type { AccordionElement }
